import { isIPhone } from '../../../utils';
export default {
  data() {
    return {
      isIPhone: isIPhone()
    };
  },
  methods: {
    handleClick() {
      this.$emit('open-click');
    }
  }
};